export default {
  snackbar: state => state.snackbar
};

// usage of getters: this.$store.getters.happyStaff
